import { format } from 'date-fns';
import { useMemo } from 'react';
import { EventAccordionItemProps } from 'src/components/Accordions';
import { InventoryEventActionDropdown } from 'src/components/Listings/InventoryActionDropdown';
import { Stack } from 'src/core/ui';
import { EventTileInfoHeader } from 'src/tiles/EventTile/MobileEventTile.components';
import { Event, Listing, Performer, Venue } from 'src/WebApiController';

import { MarkEventAsReviewed } from '../../EventHeader/EventActions/MarkEventAsReviewed';
import * as styles from './EventHeaderWithActionsMobile.css';

type EventHeaderInfoProps = {
  event: Event;
  performer?: Performer;
  venue?: Venue;
};

/**
 * Component that shows event info.
 * @param props
 * @returns
 */
const EventHeaderMobileInfo = ({
  event,
  performer,
  venue,
}: EventHeaderInfoProps) => {
  const { date, weekday, time } = useMemo(() => {
    const eventStartDate = event.dates?.start
      ? new Date(event.dates?.start)
      : new Date();
    return {
      date: format(eventStartDate, 'M/d'),
      weekday: format(eventStartDate, 'EEE'),
      time: format(eventStartDate, 'h:mmaaa').toUpperCase(),
    };
  }, [event.dates?.start]);

  return (
    <Stack width="eighty" alignItems="center" style={{ minWidth: 0 }} gap="m">
      <Stack
        alignItems="center"
        justifyContent="center"
        direction="column"
        className={styles.eventHeaderDateContainer}
      >
        <span className={styles.eventHeaderDate}>{date}</span>
        <span className={styles.eventHeaderWeekday}>{weekday}</span>
      </Stack>
      <EventTileInfoHeader
        event={event}
        performer={performer}
        venue={venue}
        time={time}
      />
    </Stack>
  );
};

export const EventHeaderWithActionsMobile = ({
  event,
  performer,
  venue,
  inventoryAccordionItem,
}: {
  event: Event;
  performer?: Performer;
  venue?: Venue;
  inventoryAccordionItem?: EventAccordionItemProps<Listing>;
}) => {
  return (
    <Stack
      width="full"
      direction="row"
      alignItems="center"
      justifyContent="spaceBetween"
      className={styles.eventHeaderCard}
    >
      <EventHeaderMobileInfo
        event={event}
        venue={venue}
        performer={performer}
      />
      <Stack direction="row" gap="s" alignItems="center">
        <MarkEventAsReviewed
          event={event}
          timeDistanceClassName={styles.eventMarkAsReviewedTimeDistance}
        />
        {inventoryAccordionItem && (
          <InventoryEventActionDropdown
            {...inventoryAccordionItem}
            hideYearFromDate={false}
            isEventPage
            useNewMoreIcon
            triggerClassName={styles.actionMoreIcon}
          />
        )}
      </Stack>
    </Stack>
  );
};
